import cn from 'classnames';
import React from 'react';
import type { SCFormFieldProps } from './form_field';
import { SCFormField } from './form_field';
import './form_field_date_time.css';
import './styles.css';

interface SCFormFieldDateTimeProps extends SCFormFieldProps {
  type?: 'date' | 'datetime-local' | 'time';
  onChange?: (value: string) => void;
}

// from eone-ui
// FIXME: inconsistency:
// eone-ui/form-string.tsx: {props.RequiredStringIndicator ?? "*"}
// eone-ui/form-input.tsx: const DefaultRequiredStringIndicator = " *";
// const DefaultRequiredStringIndicator = " *";
const DefaultRequiredStringIndicator = '*';

const SCFormFieldDateTime = (props: SCFormFieldDateTimeProps) => {
  const {
    type = 'datetime-local',
    label,
    name,
    required,
    disabled,
    rules,
    onChange,
    DataTestId,
  } = props;
  return (
    <SCFormField label={label} name={name} disabled={disabled} required={required} rules={rules}>
      {({ field }) => {
        return (
          <React.Fragment>
            {label ? (
              <div style={{ marginBottom: '7px' }}>
                <span>{label + ((required && DefaultRequiredStringIndicator) || '')}</span>
              </div>
            ) : null}
            {/*<FormLabel Label={label + ((required && DefaultRequiredStringIndicator) || '')} />*/}
            <div
              className={cn('eone-ui-input-container', 'sc-form-field-date-time', {
                disabled: field.disabled,
              })}
              data-testid={DataTestId}
            >
              <input
                type={type}
                required={required}
                disabled={field.disabled}
                value={
                  field.value ? (type === 'date' ? field.value.substring(0, 10) : field.value) : ''
                }
                onChange={(e) => {
                  field.onChange(e.target.value);
                  onChange?.(e.target.value);
                }}
                className="eone-ui-input-string"
                data-testid={DataTestId}
              />
            </div>
          </React.Fragment>
        );
      }}
    </SCFormField>
  );
};

export { SCFormFieldDateTime };
export type { SCFormFieldDateTimeProps };
